import { Component, OnInit } from '@angular/core';

import { FrameworkConfigService } from '../services/framework-config.service';
import { UserApi } from '../users/user-api';
import { MenuService } from '../services/menu.service';

@Component({
  selector: 'fw-top-bar',
  template: require('./top-bar.component.html'),
  styles: [require('./top-bar.component.css')]
})
export class TopBarComponent implements OnInit {

  constructor(private frameworkConfigService: FrameworkConfigService,
      private userApi: UserApi,
      private menuService: MenuService) { }

  ngOnInit() {
  }

  signOut() {
      this.userApi.signOut();
      this.menuService.setActiveMenuItem(null);
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/top-bar/top-bar.component.ts